import { Layout, Table, Input, Modal } from "antd";
import { Content } from "antd/es/layout/layout";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";

import { ReactComponent as ICON_ARROW_BACK_MENU } from "@assets/svgs/ICON_ARROW_BACK_MENU.svg";
import { Button } from "@components/Button";
import Header from "@components/Header";
import { Icon } from "@components/Icon";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { Text } from "@components/Text";
import { useSocketContext } from "@contexts/socket/socketContext";
import { setMediaList } from "@redux/reducers/mediaList.reducers";
import { COLOR_GREEN, COLOR_GREY, COLOR_WHITE } from "@static/COLORS";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import {
  KEY_CAMPAIGNS_ADD,
  KEY_DEVICE_MANAGEMENT_BUILDINGS_ADD,
} from "@static/PERMISSION_KEY";
import { FILTER_SIZE, MENU_SIZE, MODAL_SIZE, PAGE_SIZE } from "@static/SIZE";
import { getCampaignListTableColumns } from "@static/TABLE/BASE_CAMPAIGN_LIST_TABLE_COLUMNS";
import { getAuthUserPermissions } from "@utils/getAuthUserPermissions";
import { getAuthUserProfile } from "@utils/getAuthUserProfile";
import { fetchAPI } from "@utils/https/fetchAPI";
import { useShowConfirmation } from "@utils/useShowConfirmation";

import { FormCreate } from "./FormCreate";
import { FormEdit } from "./FormEdit";

const { REACT_APP_WITH_KIOS } = process.env;
const SectionCreate = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const SectionMainAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${COLOR_WHITE};
  padding: 8px;
  border-radius: 6px;
  height: 50px;
  box-sizing: border-box;
`;

const SectionLocationTextContainer = styled.div`
  margin-right: 8px;
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 4px;
`;

const Line = styled.div`
  height: 20px;
  width: 1px;
  background: ${COLOR_GREY};
`;

export default () => {
  const socket = useSocketContext();
  const dispatch = useDispatch();
  const showConfirmation = useShowConfirmation();
  const navigate = useNavigate();
  const location = useLocation();
  const permission = getAuthUserPermissions();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [filterText, setFilterText] = useState("");
  const [dataList, setDataList] = useState([]);

  const [selectedData, setSelectedData] = useState(null);

  const customerId = _.get(location, ["state", "customerId"]);
  const locationId = _.get(location, ["state", "locationId"]);
  const locationName = _.get(location, ["state", "locationName"]);

  const [isModalVisible, setIsModalVisible] = useState({
    isOpen: false,
    modalType: null,
  });
  const authUserProfile = getAuthUserProfile();
  const user_type = _.get(authUserProfile, ["user_type"]);

  const onHandleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const onHandleFilterChange = (e) => {
    const value = _.get(e, ["target", "value"]);
    setFilterText(value);
  };

  const onHandleCreate = ({ modalType }) => {
    setIsModalVisible({ isOpen: true, modalType });
  };

  const onHandleEdit = ({ item }) => {
    setSelectedData(item);
    setIsModalVisible({ isOpen: true, modalType: "edit" });
  };

  const onHandleDelete = async ({ item }) => {
    const id = _.get(item, ["id"]);
    const resp = await fetchAPI({
      method: "delete",
      path: `/api/v1/advertising-campaigns/${id}`,
      isAuth: true,
    });
    if (_.get(resp, ["status"])) {
      toast.success("Delete Campaign Success.");
      const updateDataList = _.chain(dataList)
        .filter((item) => {
          return _.get(item, ["id"]) !== id;
        })
        .map((item, index) => {
          return { ...item, index: index + 1 };
        })
        .value();
      setDataList(updateDataList);
    }
  };

  const filteredDataSource = _.filter(dataList, (item) => {
    const itemName = _.chain(item).get(["name"]).toLower().value();
    const lowerFilterText = _.toLower(filterText);
    return _.includes(itemName, lowerFilterText);
  });

  const initData = async () => {
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/advertising-campaigns",
      isAuth: true,
      data: { location_id: locationId, customer_id: customerId },
    });
    if (_.get(resp, ["status"])) {
      const results = _.chain(resp)
        .get(["result", "adsCampaigns"])
        .map((item, index) => {
          return { key: index, index: index + 1, ...item };
        })
        .value();

      const medias = _.chain(resp)
        .get(["result", "medias"])
        .groupBy((media) => {
          return _.chain(media).get(["type"]).split("/").first().value();
        })
        .value();
      console.log("medias :>> ", medias);
      dispatch(setMediaList(medias));
      setDataList(results);
    }
  };

  useEffect(() => {
    initData();
  }, []);

  const onHandleRedirect = ({ item }) => {
    const campaign_id = _.get(item, ["id"]);
    const campaign_name = _.get(item, ["name"]);
    const campaign_width = _.get(item, ["width"]);
    const campaign_height = _.get(item, ["height"]);
    const campaign_start_date = _.get(item, ["start_date"]);
    const campaign_end_date = _.get(item, ["end_date"]);

    const adsBlocks = _.get(item, ["adsBlocks"], []);
    const widgets = _.get(item, ["widgets"], []);

    navigate("/campaign-blocks", {
      state: {
        customerId,
        locationId,
        campaign_id,
        campaign_name,
        campaign_width,
        campaign_height,
        campaign_start_date,
        campaign_end_date,
        adsBlocks,
        widgets,
      },
    });
  };

  const onHandlePreview = ({ item }) => {
    const campaignId = _.get(item, ["id"]);
    window.open(`/preview-campaign/${campaignId}`, "_blank");
  };

  const handleKiosUpdateContent = ({ item }) => {
    console.log("item :>> ", item);
    socket.emit("BACK-OFFICE-SEND-KIOS-VIEW-UPDATE-CONTENT-WITH-CAMPAIGN-ID", {
      campaignId: _.get(item, ["id"]),
    });
  };

  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: MENU_SIZE }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents>
            <SectionMainAction>
              <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                <Button onClick={() => navigate(-1)} padding="0px">
                  <Icon
                    isCursor
                    width={14}
                    height={14}
                    style={{ marginRight: 8 }}
                  >
                    <ICON_ARROW_BACK_MENU />
                  </Icon>
                  <Text fontSize="18px" fontWeight="600">
                    Back
                  </Text>
                </Button>
                <Line />

                <Input
                  placeholder="Filter by name"
                  value={filterText}
                  onChange={(e) => onHandleFilterChange(e)}
                  style={{ width: FILTER_SIZE }}
                />
              </div>

              <SectionCreate>
                <SectionLocationTextContainer>
                  <Text
                    fontSize="16px"
                    fontWeight="400"
                    color="rgb(150 150 150)"
                  >
                    Project
                  </Text>
                  <Text
                    fontSize="16px"
                    fontWeight="400"
                    color="rgb(150 150 150)"
                  >
                    :
                  </Text>
                  <Text
                    fontSize="16px"
                    fontWeight="500"
                    isEllipsis
                    lines={1}
                    isBreak
                  >
                    {locationName}
                  </Text>
                </SectionLocationTextContainer>

                {_.includes(permission, KEY_CAMPAIGNS_ADD) && (
                  <Button
                    onClick={() => onHandleCreate({ modalType: "create" })}
                    color={COLOR_GREEN}
                    fontColor={COLOR_WHITE}
                    padding="7px 15px"
                  >
                    Add Campaigns
                  </Button>
                )}
              </SectionCreate>
            </SectionMainAction>

            <Table
              dataSource={filteredDataSource}
              columns={getCampaignListTableColumns({
                isWithKios: REACT_APP_WITH_KIOS === "true",
                userType: user_type,
                permission,
                handleKiosUpdateContent,
                onHandlePreview,
                onHandleEdit,
                onHandleDelete,
                onHandleRedirect,
                showConfirmation,
              })}
              pagination={{
                position: ["bottomRight"],
                current: currentPage,
                pageSize: pageSize,
                showSizeChanger: true,
              }}
              scroll={{ x: 1200 }}
              onChange={onHandleTableChange}
            />
          </InnerContents>
        </Content>
      </Layout>
      <Modal
        width={MODAL_SIZE}
        destroyOnClose={true}
        title={`${_.chain(isModalVisible)
          .get(["modalType"])
          .capitalize()
          .value()} Campaign`}
        open={_.get(isModalVisible, ["isOpen"])}
        footer={null}
        onCancel={() =>
          setIsModalVisible((prev) => ({ ...prev, isOpen: false }))
        }
      >
        {_.get(isModalVisible, ["modalType"]) === "create" && (
          <FormCreate
            customerId={customerId}
            locationId={locationId}
            userProfile={authUserProfile}
            setIsModalVisible={setIsModalVisible}
            setDataList={setDataList}
            dataList={dataList}
          />
        )}
        {_.get(isModalVisible, ["modalType"]) === "edit" && (
          <FormEdit
            userProfile={authUserProfile}
            selectedData={selectedData}
            setIsModalVisible={setIsModalVisible}
            setDataList={setDataList}
            setSelectedData={setSelectedData}
          />
        )}
      </Modal>
    </Layout>
  );
};
